export enum UserRights {
    add = "add",
    edit = "edit",
    delete = "delete",
    view = "view",
}